import { useEffect, useState } from "react";
import { Loader2, Mail } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";

export function StudioAlertsCard() {
    const [state, setState] = useState(null);
    const [email, setEmail] = useState("");
    const [saving, setSaving] = useState(false);

    useEffect(() => {
        api.get("/partner/studio-alerts")
            .then(({ data }) => {
                setState(data);
                setEmail(data.notify_email || "");
            })
            .catch(() => setState({ enabled: false }));
    }, []);

    if (!state?.enabled) return null;

    const save = async () => {
        setSaving(true);
        try {
            const { data } = await api.put("/partner/studio-alerts", { notify_email: email });
            setState(data);
            toast.success("Alert email saved.");
        } catch (err) {
            toast.error(err?.response?.data?.detail?.[0]?.msg || err?.response?.data?.detail || "Could not save email.");
        } finally {
            setSaving(false);
        }
    };

    return (
        <div className="mb-8 p-5 border border-cream/15 rounded-sm" data-testid="studio-alerts-card">
            <p className="text-[0.62rem] tracking-[0.3em] uppercase text-gold inline-flex items-center gap-1.5">
                <Mail size={12} /> Settings · Studio message alerts
            </p>
            <p className="mt-2 text-sm text-cream">
                When a customer sends the "Tell the studio" form, we email this address.
            </p>
            <div className="mt-4 flex flex-wrap gap-2">
                <input
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    className="flex-1 min-w-[220px] bg-transparent border border-cream/30 rounded-sm px-3 py-2 text-sm text-cream"
                    data-testid="studio-alerts-email-input"
                />
                <button
                    onClick={save}
                    disabled={saving || !email.includes("@")}
                    className="btn-pill btn-ghost text-[0.65rem]"
                    data-testid="studio-alerts-save-btn"
                >
                    {saving ? <Loader2 size={12} className="animate-spin" /> : null} Save
                </button>
            </div>
        </div>
    );
}
